<template>
  <div class="border bg-light">
    <ul class="d-sm-flex justify-content-around mb-0 p-2 legend">
      <li class="LM">
        <span><b-icon icon="info-circle-fill" class="mr-2"/><translate>Info Hotel</translate></span>
      </li>
      <li class="SPO">
        <span><b-icon icon="tag-fill" class="mr-2 text-danger"/><translate>Special Offer</translate></span>
      </li>
      <li  class="EBD">
        <span><b-icon icon="clock" class="mr-2 text-info"/><translate>Early Booking</translate></span>
      </li>
      <li class="FC">
        <span><b-icon icon="person-plus-fill" class="mr-2"/><translate>Free Child</translate></span>
      </li>
      <li  class="FCAVL">
        <span><b-icon icon="check-circle" class="mr-2 text-success"/><translate>Available</translate></span>
      </li>
      <li  class="RQNA">
        <span><b-icon icon="check-circle" class="mr-2"/><translate>On Request</translate></span>
      </li>
      <li  class="SPOEBD">
        <span><b-icon icon="slash-circle" class="mr-2"/><translate>Unavailable</translate></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Legend'
}
</script>

<style scoped>
   li.SPO,
   li.LM,
   li.FC,
   li.FCAVL,
   li.RQNA,
   li.SPOEBD,
   li.EBD{
     font-size: 13px;
   }
</style>
